<app-spinner *ngIf="loading"></app-spinner>

<div *ngIf="!loading" fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="30px">

    <mat-card>
        <mat-card-header>
            <mat-card-title>{{ title }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="mailListForm" (submit)="onSubmit()">
                <mat-form-field>
                    <input matInput placeholder="{{'MAIL-LIST-DETAILS.NAME' | translate}}" formControlName="name">
                </mat-form-field>
                <div style="display: flex;justify-content: space-between;">
                    <h2>{{'MAIL-LIST-DETAILS.CONTACTS' | translate}} ({{ contactList?.length || 'no contacts '}})</h2>
                    <button  mat-icon-button (click)="importContacts($event)" style="color: grey;">
                        <mat-icon>text_snippet</mat-icon>
                    </button>
                </div>
                <input type="file" style="display: none" #fileInput (change)="onFileSelected()" />
                <div class="contact-row" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">
                    <div class="contact-header-cell" fxFlex="1 1 50px">#</div>
                    <div *ngFor="let field of contactFields" class="contact-header-cell" fxFlex="1 1 12%">{{ field.title | translate }}</div>
                </div>
                <cdk-virtual-scroll-viewport [itemSize]="20" class="contact-virtual-table">
                    <div class="contact-row" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px" *cdkVirtualFor = "let contact of contactList; let rowIndex = index">
                        <div class="contact-cell" fxLayout="row" fxLayoutAlign="center center" fxFlex="1 1 50px">{{ (rowIndex + 1) }}</div>
                        <div *ngFor="let field of contactFields" (click)="setActiveCell(rowIndex, field.key)"
                            class="contact-cell" [ngClass]="{active: isActive(rowIndex, field.key)}"
                            fxFlex="1 1 12%" fxLayout="row" fxLayoutAlign="space-between center">
                            <ng-container *ngIf="!isActive(rowIndex, field.key)">
                                <div class="cell-content">{{ contact[field.key] }}</div>
                                <mat-icon class="edit-icon">edit</mat-icon>
                            </ng-container>
                            <ng-container *ngIf="isActive(rowIndex, field.key)">
                                <mat-form-field (blur)="clearActiveCell($event)">
                                    <input matInput [formControl]="activeCellControl" placeholder="{{ field.title | translate }}">
                                    <mat-icon matSuffix class="save-icon" (click)="saveActiveCell($event)">check</mat-icon>
                                </mat-form-field>
                            </ng-container>
                        </div>
                    </div>
                </cdk-virtual-scroll-viewport>
                <!-- <div fxLayout="column" formArrayName="contacts" *ngFor="let date of contactsFormArray; index as i">
                    <div [formGroupName]="i" fxLayout="row" fxLayoutGap="15px">
                        <mat-form-field>
                            <input matInput formControlName="firstName" placeholder="{{'MAIL-LIST-DETAILS.FIRSTNAME' | translate}}">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="lastName" placeholder="{{'MAIL-LIST-DETAILS.LASTNAME' | translate}}">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="email" placeholder="{{'MAIL-LIST-DETAILS.EMAIL' | translate}}">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="company" placeholder="{{'MAIL-LIST-DETAILS.COMPANY' | translate}}">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="department" placeholder="{{'MAIL-LIST-DETAILS.CLASS' | translate}}">
                        </mat-form-field>
                        <mat-form-field>
                            <input matInput formControlName="mobile" placeholder="{{'MAIL-LIST-DETAILS.PHONE' | translate}}">
                        </mat-form-field>
                    </div>
                </div> -->

                <div class="card-footer" fxLayout="flex" fxLayoutAlign="center center" fxLayoutGap="15px">
                    <button mat-raised-button color="primary" type="submit">{{'MAIL-LIST-DETAILS.SAVE' | translate}}</button>
                    <button mat-raised-button color="warn" (click)="delete($event)">{{'MAIL-LIST-DETAILS.DELETE' | translate}}</button>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</div>